<form [formGroup]="form">
    <div class="edit-actions">
        <mat-spinner *ngIf="loadingAction" matSuffix [diameter]="20"></mat-spinner>

        <button *ngIf="!loadingAction" matTooltip="Cancelar" (click)="cancel()" mat-icon-button class="card-inline">
      <mat-icon>clear</mat-icon>
    </button>
        <button *ngIf="!loadingAction && !canReverse && !isReadOnly && !editInWord()" matTooltip="Guardar" (click)="update()" mat-icon-button class="card-inline">
      <mat-icon>account_balance_wallet</mat-icon>
    </button>
        <button *ngIf="canReverse" matTooltip="Revertir" (click)="studyReportStateReverse()" mat-icon-button class="card-inline">
      <mat-icon>undo</mat-icon>
    </button>
        <button *ngIf="!loadingAction && !canReverse" mat-icon-button [matMenuTriggerFor]="menuItem">
      <mat-icon>more_vert</mat-icon>
    </button>
        <mat-menu #menuItem="matMenu">
            <app-medical-appointment-reappointment-control (onReAppointmentChange)="onReAppointmentChange()" [medicalAppointmentId]="medicalApponitmentId">
            </app-medical-appointment-reappointment-control>
        </mat-menu>
    </div>

    <mat-tab-group #tabGroup (animationDone)="updateEditor()" (selectedTabChange)="selectedTabChange($event)">
        <mat-tab label="Escaneos">
            <div class="card-base margin-botton-medium">
                <div class="card-content-scan">
                    <div class="card-container mat-elevation-z1">
                        <div class="card-content">
                            <medical-order-scann-control [medicalorderId]="medicalorderId"></medical-order-scann-control>
                        </div>
                    </div>
                </div>
            </div>
        </mat-tab>
        <mat-tab label="Datos generales e informe">
            <div class="card-base margin-botton-medium">
                <div class="card-content-wizard" (resized)="onResized($event)">
                    <app-study-report-edit-control (confirm)="studyReportConfirmed($event)" *ngIf="
              loadEditor &&
              !loading &&
              !getSafeResourceUrl() &&
              !editInWord() &&
              !txControlEnabled
            " formControlName="StudyReportEdit"></app-study-report-edit-control>

                    <iframe style="width: 100%" height="500" *ngIf="isReadOnly && getSafeResourceUrl()" [src]="getSafeResourceUrl()" type="application/pdf"></iframe>
                    <mat-spinner *ngIf="loading" matSuffix></mat-spinner>
                </div>
            </div>
        </mat-tab>
        <mat-tab label="Paciente">
            <div class="card-base margin-botton-medium">
                <div class="card-content-wizard">
                    <study-report-patient-component></study-report-patient-component>
                </div>
            </div>
        </mat-tab>
        <mat-tab label="Médico derivante">
            <div class="card-content-wizard">
                <app-study-report-referring-physician></app-study-report-referring-physician>
            </div>
        </mat-tab>

        <mat-tab label="Archivos adjuntos">
            <div class="card-base margin-botton-medium">
                <div class="card-content-wizard">
                    <app-study-report-attach-file [studyReportId]="studyReportId"></app-study-report-attach-file>
                </div>
            </div>
        </mat-tab>
        <mat-tab label="HC imágenes">
            <div class="card-base margin-botton-medium">
                <div class="card-content-wizard">
                    <study-report-clinic-history-component></study-report-clinic-history-component>

                    <br />
                    <div style="margin-top: 5px">
                        <app-previus-studies-links-control *ngIf="medicalApponitmentId" [appointmentId]="medicalApponitmentId"></app-previus-studies-links-control>
                    </div>
                </div>
            </div>
        </mat-tab>
        <mat-tab label="Hc consultas">
            <div class="card-base margin-botton-medium">
                <div class="card-content-wizard">
                    <app-study-report-consultation-history-component></app-study-report-consultation-history-component>
                </div>
            </div>
        </mat-tab>
        <mat-tab label="Operaciones">
            <div class="card-base margin-botton-medium">
                <div class="card-content-scan">
                    <study-report-operation-component></study-report-operation-component>
                </div>
            </div>
        </mat-tab>
    </mat-tab-group>

    <div class="card-base margin-botton-medium" *ngIf="reportTabActivated && !loading && !getSafeResourceUrl() && !editInWord() && txControlEnabled" [style.display]="activeTabIndex === 1 ? 'block' : 'none'">
        <div class="card-content-wizard">
            <app-study-report-edit-tx-control #txControlReportEdit (confirm)="studyReportConfirmed($event)" formControlName="StudyReportEdit"></app-study-report-edit-tx-control>
        </div>
    </div>
</form>
